<template>
  <div id="paypal-button-component">
    <div id="paypal-button-container"></div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';
  import loadjs from 'loadjs';
  import appConfig from '@/app.config';

  const { PAYPAL_CLIENT_ID } = appConfig;

  /* eslint-disable */

  export default {
    name: 'PayPalBtn',
    props: {
      order: {
        require: true,
        type: Object,
      }
    },
    mounted() {
      var paypalScript = `https://www.paypal.com/sdk/js?client-id=${PAYPAL_CLIENT_ID}&currency=${this.order.currency}`;
      if (process.env.NODE_ENV === 'development') {
        paypalScript += '&debug=true';
      }
      loadjs.reset();
      loadjs(paypalScript, 'paypal');
      loadjs.ready('paypal', this.render);
    },
    methods: {
      render() {
        const vm = this;
        const color = this.isMobile ? 'blue' : 'gold'
        paypal.Buttons({
          style: {
            layout: 'vertical',
            color: color,
            shape: 'rect',
            label: 'paypal',
          },
          createOrder() {
            const params = {
              order_id: vm.order.id,
            };
            return vm.$api.paypalv2.create(params)
              .then(({ data: response }) => {
                return response.id
              })
              .catch((error) => {
                if (error.response) {
                  this.$notify({
                    type: 'danger',
                    message: error.response.data.message,
                  });
                }
              });
          },
          onApprove(data) {
            return vm.$api.paypalv2.capture(data.orderID)
              .then(({ data: response }) => {
                this.$notify({
                  type: 'success',
                  title: '已成功支付',
                });
                this.$router.push({ name: 'order-detail', params: { id: vm.order.id } });
                return response;
              })
              .catch((error) => {
                this.$notify({
                  title: error.response.data.message,
                  type: 'danger',
                });
              });
          },
        }).render('#paypal-button-container');
      },
    },
    computed: {
      ...mapState({
        app: state => state.app,
      }),
      ...mapGetters([
        'isMobile',
      ])
    },
  };
</script>

<style lang="scss">
  #paypal-button-component {

  }
</style>
